(function()  {
     // Escape HTML to prevent XSS
    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    // Show error message
    function showError(container, message) {
        container.innerHTML = `<div class="error-message"><strong>Error:</strong> ${message}</div>`;
    }

    async function initMaps() {
        try {
            const { Map, InfoWindow } = await google.maps.importLibrary("maps");
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

            const maps = document.querySelectorAll("[data-gmap]");

            if (!maps || maps.length === 0) {
                console.warn('No map containers found');
                return;
            }

            maps.forEach(map => initializeMap(map, Map, InfoWindow, AdvancedMarkerElement));
        } catch (error) {
                console.error('Failed to initialize Google Maps:', error);
                showError(document.querySelector("[data-gmap]"), 'Failed to load Google Maps');
        }
    }

    function createBasicInfoContent(location) {
        const title = escapeHtml(location.title || 'Location');
        const address = location.address ? escapeHtml(location.address) : '';
        const description = location.description ? escapeHtml(location.description) : '';

        return `
            <div class="info-window-content">
                <div class="info-title">${title}</div>
                ${address ? `<div class="info-address">${address}</div>` : ''}
                ${description ? `<div class="info-description">${description}</div>` : ''}
            </div>
        `;
    }

    function initializeMap(mapContainer, Map, InfoWindow, AdvancedMarkerElement) {
                try {
                // Get locations data from attribute
                const locationsMapping = mapContainer.getAttribute("data-map-locations");
                const mapId = mapContainer.getAttribute("data-gmap");

                if (!locationsMapping) {
                    showError(mapContainer, 'No location data found');
                    return;
                }

                // Parse locations JSON
                let locations;
                try {
                    locations = JSON.parse(locationsMapping);
                } catch (error) {
                    showError(mapContainer, 'Invalid location data format');
                    return;
                }

                if (!Array.isArray(locations) || locations.length === 0) {
                    showError(mapContainer, 'No valid locations found');
                    return;
                }

                // Validate and filter locations
                const validLocations = locations.filter(location => {
                    if (!location.lat || !location.lng) {
                        console.warn('Skipping location without coordinates:', location);
                        return false;
                    }

                    const lat = parseFloat(location.lat);
                    const lng = parseFloat(location.lng); // FIX: Use location.lng instead of location.lat

                    if (isNaN(lat) || isNaN(lng)) {
                        console.warn('Skipping location with invalid coordinates:', location);
                        return false;
                    }

                    if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
                        console.warn('Skipping location with out-of-range coordinates:', location);
                        return false;
                    }

                    return true;
                });

                if (validLocations.length === 0) {
                    showError(mapContainer, 'No locations with valid coordinates found');
                    return;
                }

                // Calculate center point from all locations
                const bounds = new google.maps.LatLngBounds();
                validLocations.forEach(location => {
                    bounds.extend(new google.maps.LatLng(
                        parseFloat(location.lat),
                        parseFloat(location.lng)
                    ));
                });

                let mapCenter = bounds.getCenter();

                // Create the map
                const map = new Map(mapContainer, {
                    center: { lat: mapCenter.lat(), lng: mapCenter.lng() },
                    zoom: 15,
                    mapId: '2977727cffbb86f486feb51c', // You should use your own Map ID
                    disableDefaultUI: false,
                    zoomControl: true,
                    streetViewControl: false,
                    fullscreenControl: true,
                });

                // Arrays to store markers and info windows
                const markers = [];
                const infoWindows = [];
                const padding = { top: 15, right: 15, bottom: 15, left: 15 };

                // Create markers for each location
                validLocations.forEach((location, index) => {
                    const lat = parseFloat(location.lat);
                    const lng = parseFloat(location.lng); // FIX: Use location.lng instead of location.lat

                    // Create individual custom icon for each marker (FIX: Don't reuse same element)
                    let markerContent = null;

                    if (location.pin_image) {
                        // Handle custom pin image
                        const customIcon = document.createElement("img");
                        let pinUrl = location.pin_image;

                        // Clean up URL if needed
                        if (pinUrl.startsWith('//')) {
                            pinUrl = `https:${pinUrl.split('?')[0]}`;
                        }

                        customIcon.src = pinUrl;
                        customIcon.style.width = "40px";
                        customIcon.style.height = "40px";
                        customIcon.style.cursor = "pointer";
                        customIcon.alt = location.title || `Location ${index + 1}`;

                        // Handle image load errors
                        customIcon.onerror = function() {
                            console.warn('Failed to load pin image:', pinUrl);
                            // Fallback to default marker (no content)
                        };

                        markerContent = customIcon;
                    }
                    // If no pin_image, use default marker (markerContent remains null)

                    // Create marker
                    const marker = new AdvancedMarkerElement({
                        position: { lat: lat, lng: lng },
                        map: map, // FIX: Use map instance, not DOM element
                        content: markerContent, // Will be null for default markers
                        title: location.title || `Location ${index + 1}`
                    });

                    markers.push(marker);

                    // Create info window if template exists
                    let infoWindow = null;
                    if (location.id) {
                        const infoWindowEl = document.querySelector(`[data-gmap-info-windows-container="${mapId}"] [data-gmap-info-window="${location.id}"]`);

                        if (infoWindowEl) {
                            const infoWindowElCloned = infoWindowEl.cloneNode(true);
                            const infoContent = infoWindowElCloned.innerHTML;

                            if (infoContent.trim()) {
                                infoWindow = new InfoWindow({
                                    content: infoContent,
                                });
                            }
                        }
                    }

                    // Fallback: create basic info window if no template found
                    if (!infoWindow && location.title) {
                        const basicContent = createBasicInfoContent(location);
                        infoWindow = new InfoWindow({
                            content: basicContent,
                        });
                    }

                    if (infoWindow) {
                        infoWindows.push(infoWindow);

                        let zoomOnInit = map.getZoom();
                        let positionOnInit = map.getCenter();

                        // Add click listener to marker
                        marker.addListener('click', () => {
                            zoomOnInit = map.getZoom();
                            positionOnInit = map.getCenter();

                            infoWindows.forEach(iw => iw.close());

                            infoWindow.open({
                                anchor: marker,
                                map: map
                            });

                            map.setCenter(infoWindow.getPosition());
                            map.setZoom(15);
                        });

                        // Add close listener to info window
                        infoWindow.addListener('closeclick', () => {
                            map.setCenter(positionOnInit);
                            map.setZoom(zoomOnInit);
                        });
                    }
                });

                // Fit map bounds to show all markers
                if (markers.length > 1) {
                    map.fitBounds(bounds, padding);
                } else if (markers.length === 1) {
                    // For single marker, set a reasonable zoom level
                    map.setZoom(15);
                }

            } catch (error) {
                console.error('Error initializing map:', error);
                showError(mapContainer, 'Failed to initialize map');
            }
    };

    // Defer loading the Google Maps library until a map container is about to
    // enter the viewport, so it doesn't compete with the LCP image on load.
    function lazyInitMaps() {
        const maps = document.querySelectorAll("[data-gmap]");

        if (!maps || maps.length === 0) {
            return;
        }

        if (!('IntersectionObserver' in window)) {
            initMaps();
            return;
        }

        let initialized = false;
        const observer = new IntersectionObserver((entries) => {
            if (initialized) return;
            if (entries.some(entry => entry.isIntersecting)) {
                initialized = true;
                observer.disconnect();
                initMaps();
            }
        }, { rootMargin: '400px' });

        maps.forEach(map => observer.observe(map));
    }

    function start() {
        if (window.googleMapConsent) {
            window.googleMapConsent.onAccept(lazyInitMaps);
        } else {
            lazyInitMaps();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();


